import React from 'react';
import Menu from '@hud/web-components/Menu/Menu';
import { Button, Icon, Item } from './EnvironmentMenu.styles';
import useEnvironment from '../../hooks/useEnvironment';
import _ from 'lodash';
import { EnvironmentRef } from '@hud/portal-dtos/webapp-common.dto';
import { HudIconProps } from '@hud/web-components/Icons/HudIcons';
import Tooltip from '@hud/web-components/Tooltip/Tooltip';

export const commonEnvironmentIcons: Record<
  EnvironmentRef['name'],
  HudIconProps['icon']
> = {
  production: 'lights.turquoise',
  staging: 'lights.yellow',
};

const getEnvIcon = (environment: EnvironmentRef): HudIconProps['icon'] => {
  if (commonEnvironmentIcons[environment.name]) {
    return commonEnvironmentIcons[environment.name];
  }
  return 'lights.blue' as HudIconProps['icon'];
};

export default function EnvironmentMenu({ enabled = true }) {
  const { environment, environments, setEnvironment } = useEnvironment();
  if (!environment || !environments) {
    return null;
  }

  const fullButton = (
    <Button disabled={!enabled}>
      <Icon
        icon={getEnvIcon(environment)} // or iterate over customColors
        size="14px"
      />
      {_.capitalize(environment.name)}
      <Icon icon="menu.caretDown" size="14px" />
    </Button>
  );

  return (
    <Menu.Menu>
      <Menu.Target>
        <div>
          {enabled ? (
            fullButton
          ) : (
            <Tooltip description="Selector is disabled for this page">
              {fullButton}
            </Tooltip>
          )}
        </div>
      </Menu.Target>
      {enabled && (
        <Menu.Dropdown>
          {environments.map((environment) => (
            <Item
              key={environment.id}
              onClick={() => setEnvironment(environment)}
            >
              <Icon icon={getEnvIcon(environment)} size="14px" />
              {_.capitalize(environment.name)}
            </Item>
          ))}
        </Menu.Dropdown>
      )}
    </Menu.Menu>
  );
}
